import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { DemandWalkEditsContext } from "../contexts/demand_walk_edits";
import { DemandPlanEditsContext } from "../contexts/demand_plan_edits";
import { PurchasingCalendarEditsContext } from "../contexts/purchasing_calendar_edits";

export interface EditContextActions {
  editMode: boolean;
  loading: boolean;
  setEditMode: (mode: boolean) => void;
  saveEditsAndTriggerRun: (runName: string) => Promise<void>;
  discardChanges: () => void;
}

/**
 * Returns the active edit context based on the current route.
 * Used by EditModeToggle and useForceUserEditConclude so they
 * don't need to hardcode a specific edit context.
 */
export function useActiveEditContext(): EditContextActions {
  const { pathname } = useLocation();
  const demandWalk = useContext(DemandWalkEditsContext);
  const demandPlan = useContext(DemandPlanEditsContext);
  const purchasingCalendar = useContext(PurchasingCalendarEditsContext);

  if (pathname.startsWith("/demand-plan")) {
    return {
      editMode: demandPlan.editMode,
      loading: demandPlan.loading,
      setEditMode: demandPlan.setEditMode,
      saveEditsAndTriggerRun: demandPlan.saveEditsAndTriggerRun,
      discardChanges: demandPlan.discardChanges,
    };
  }

  if (pathname.startsWith("/purchasing-calendar")) {
    return {
      editMode: purchasingCalendar.editMode,
      loading: purchasingCalendar.loading,
      setEditMode: purchasingCalendar.setEditMode,
      saveEditsAndTriggerRun: purchasingCalendar.saveEditsAndTriggerRun,
      discardChanges: purchasingCalendar.discardChanges,
    };
  }

  // Default to demand walk (existing behavior)
  return {
    editMode: demandWalk.editMode,
    loading: demandWalk.loading,
    setEditMode: demandWalk.setEditMode,
    saveEditsAndTriggerRun: demandWalk.saveEditsAndTriggerRun,
    discardChanges: demandWalk.discardChanges,
  };
}
